"use strict";

var _interopRequireWildcard = require("@babel/runtime-corejs3/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");

var _Object$defineProperty2 = require("@babel/runtime-corejs3/core-js-stable/object/define-property");

_Object$defineProperty2(exports, "__esModule", {
  value: true
});

exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-property"));

var _defineProperties = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/define-properties"));

var _getOwnPropertyDescriptors = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptors"));

var _getOwnPropertyDescriptor = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-descriptor"));

var _filter = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/filter"));

var _getOwnPropertySymbols = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/get-own-property-symbols"));

var _keys = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/object/keys"));

var _construct = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/reflect/construct"));

var _forEach = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/for-each"));

var _concat = _interopRequireDefault(require("@babel/runtime-corejs3/core-js-stable/instance/concat"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/getPrototypeOf"));

var _defineProperty3 = _interopRequireDefault(require("@babel/runtime-corejs3/helpers/defineProperty"));

require("../../util/GlobalScript.js");

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _classnames = _interopRequireDefault(require("classnames"));

var _underscore = _interopRequireDefault(require("underscore"));

function ownKeys(object, enumerableOnly) { var keys = (0, _keys.default)(object); if (_getOwnPropertySymbols.default) { var symbols = (0, _getOwnPropertySymbols.default)(object); if (enumerableOnly) symbols = (0, _filter.default)(symbols).call(symbols, function (sym) { return (0, _getOwnPropertyDescriptor.default)(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { var _context10; (0, _forEach.default)(_context10 = ownKeys(Object(source), true)).call(_context10, function (key) { (0, _defineProperty3.default)(target, key, source[key]); }); } else if (_getOwnPropertyDescriptors.default) { (0, _defineProperties.default)(target, (0, _getOwnPropertyDescriptors.default)(source)); } else { var _context11; (0, _forEach.default)(_context11 = ownKeys(Object(source))).call(_context11, function (key) { (0, _defineProperty2.default)(target, key, (0, _getOwnPropertyDescriptor.default)(source, key)); }); } } return target; }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = (0, _construct.default)(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct.default) return false; if (_construct.default.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct.default)(Date, [], function () {})); return true; } catch (e) { return false; } }

/**
* @callback FileDrop~onRemove
*/

/**
* @callback FileDrop~onValueChange
*
* @param {Object} file
*     The file object
* @param {Object} e
*     The even object provided with the onChange event
*/

/**
* @callback FileDrop~onValidateFile
*
* @param {boolean} isValidFile
*     A boolean indicating whether the file type is one the accepted file types.
* @param {Object} file
*     The file object
* @param {Object} e
*     The even object provided with the onChange event
*/

/**
 * @class FileDrop
 * @desc A single-selection component with big icons and titles.
 *
 * @param {string} [data-id="file-drop"]
 *     Defines the "data-id" for top-level HTML container.
 * @param {string[]} [accept]
 *     An optional array of the the allowed file mime types or file extensions.
 * @param {string} [className]
 *     Optional CSS classname(s) applied to top-level container.
 * @param {boolean} [disabled=false]
 *     Input will will not function when true.
 * @param {node} [fileName]
 *     The name of the currently selected file.
 * @param {FileDrop~onRemove} [onRemove]
 *     The callback triggered when the remove file link is clicked.
 * @param {FileDrop~onValueChange} [onValueChange]
 *     A callback triggered when a file is dropped or selected.
 * @param {FileDrop~onValidateFile} [onValidateFile]
 *     The callback triggered when when a file is selected that idicates if the selected file type matches those allowed by the "accept" prop.
 * @param {Object} [strings]
 *     An object containing the various blurbs of text rendered in the component.
 *
 * @example
 *     <FileDrop
 *         onValueChange={this._handleChange}
 *         onRemove={this._handleRemove}
 *         fileName={this.state.selectedFile}
 *         accept={["text/csv", "image/jpeg", "image/png"]}
 *     />
 *
 */
var FileDrop = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(FileDrop, _Component);

  var _super = _createSuper(FileDrop);

  function FileDrop() {
    var _context;

    var _this;

    (0, _classCallCheck2.default)(this, FileDrop);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, (0, _concat.default)(_context = [this]).call(_context, args));
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "state", {
      hovered: false
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "defaultStrings", {
      drop: "Drag and drop a file here to upload",
      separator: "or",
      select: "Select a file",
      change: "Change file",
      remove: "Remove file"
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onHover", function () {
      return _this.setState({
        hovered: true
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onExit", function () {
      return _this.setState({
        hovered: false
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onInputChange", function (e) {
      var file = e.target.files ? e.target.files[0] : null;

      _this._handleFileChange(file, e);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_onDrop", function (e) {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this._preventDefaults(e);

      var file = e.dataTransfer && e.dataTransfer.files ? e.dataTransfer.files[0] : null;

      _this._handleFileChange(file, e);
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleFileChange", function (file, e) {
      // needed for when canceling out of the file dialog
      if (!file) {
        return;
      } // Only keeping this in here for backwards compatibility. Existing file validation in this
      // component duplicated the functionality of <input> accept and did it very badly.


      _this.props.onValidateFile(true, file, e);

      _this.props.onValueChange(file, e, {
        remove: _this._handleRemove
      });
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_clickInput", function () {
      _this.fileInput.click();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_handleRemove", function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.fileInput.value = null;

      _this.props.onRemove();
    });
    (0, _defineProperty3.default)((0, _assertThisInitialized2.default)(_this), "_getInputRef", function () {
      return _this.fileInput;
    });
    return _this;
  }

  (0, _createClass2.default)(FileDrop, [{
    key: "_preventDefaults",
    value: function _preventDefaults(e) {
      e.preventDefault();
      e.stopPropagation();
    }
  }, {
    key: "componentDidMount",
    value: function componentDidMount() {
      var _context2,
          _this2 = this,
          _context3,
          _context4,
          _context5;

      (0, _forEach.default)(_context2 = ["dragenter", "dragleave", "dragover", "drop"]).call(_context2, function (eventName) {
        _this2.dropFile.addEventListener(eventName, _this2._preventDefaults, false);
      });
      (0, _forEach.default)(_context3 = ["dragleave", "drop"]).call(_context3, function (eventName) {
        _this2.dropFile.addEventListener(eventName, _this2._onExit, false);
      });
      (0, _forEach.default)(_context4 = ["dragenter", "dragover"]).call(_context4, function (eventName) {
        _this2.dropFile.addEventListener(eventName, _this2._onHover, false);
      });
      (0, _forEach.default)(_context5 = ["drop"]).call(_context5, function (eventName) {
        _this2.dropFile.addEventListener(eventName, _this2._onDrop, false);
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      var _context6,
          _this3 = this,
          _context7,
          _context8,
          _context9;

      (0, _forEach.default)(_context6 = ["dragenter", "dragleave", "dragover", "drop"]).call(_context6, function (eventName) {
        _this3.dropFile.removeEventListener(eventName, _this3._preventDefaults);
      });
      (0, _forEach.default)(_context7 = ["dragleave", "drop"]).call(_context7, function (eventName) {
        _this3.dropFile.removeEventListener(eventName, _this3._onExit);
      });
      (0, _forEach.default)(_context8 = ["dragenter", "dragover"]).call(_context8, function (eventName) {
        _this3.dropFile.removeEventListener(eventName, _this3._onHover);
      });
      (0, _forEach.default)(_context9 = ["drop"]).call(_context9, function (eventName) {
        _this3.dropFile.removeEventListener(eventName, _this3._onDrop);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props = this.props,
          accept = _this$props.accept,
          renderContent = _this$props.renderContent,
          className = _this$props.className,
          dataId = _this$props["data-id"],
          fileName = _this$props.fileName,
          hovered = _this$props.hovered,
          replaceContent = _this$props.replaceContent,
          onRemove = _this$props.onRemove,
          disabled = _this$props.disabled;
      var fileSelected = !!fileName;
      var classNames = {
        "input-filedrop--hover": hovered,
        "input-filedrop--selected": fileSelected,
        "input-filedrop--replace-content": replaceContent,
        "input-filedrop--disabled": disabled
      };

      var text = _objectSpread(_objectSpread({}, this.defaultStrings), this.props.strings);

      var customContent = typeof renderContent === "function";
      var Element = replaceContent ? "span" : "div";
      return /*#__PURE__*/_react.default.createElement(Element, {
        "data-id": dataId,
        ref: function ref(df) {
          return _this4.dropFile = df;
        },
        className: (0, _classnames.default)("input-filedrop", className, classNames)
      }, customContent && // sending the ref over rather than a function to get the ref doesn't always work
      renderContent({
        inputRef: this.fileInput,
        getInputRef: this._getInputRef
      }), !customContent && (fileSelected ? /*#__PURE__*/_react.default.createElement("div", {
        className: "input-filedrop__selected-content",
        title: fileName
      }, /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "".concat(dataId, "-icon"),
        className: "icon-check icon__rounded input-filedrop__icon"
      }), /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "".concat(dataId, "-file-name"),
        className: "input-filedrop__selected-text"
      }, fileName), /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "".concat(dataId, "-change-link"),
        onClick: this._clickInput,
        className: "input-filedrop__link input-filedrop__divider"
      }, text.change), onRemove && /*#__PURE__*/_react.default.createElement("span", {
        "data-id": "".concat(dataId, "-remove-link"),
        className: "input-filedrop__link input-filedrop__divider",
        onClick: this._handleRemove
      }, text.remove)) : /*#__PURE__*/_react.default.createElement("div", {
        className: "input-filedrop__upload-text",
        key: "input-filedrop__upload-text"
      }, /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "".concat(dataId, "-drop-text")
      }, text.drop), /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "".concat(dataId, "-separator-text")
      }, text.separator), /*#__PURE__*/_react.default.createElement("div", {
        "data-id": "".concat(dataId, "-select-link"),
        className: "input-filedrop__link"
      }, text.select))), /*#__PURE__*/_react.default.createElement("label", {
        key: "label",
        "data-id": "".concat(dataId, "-label")
      }, /*#__PURE__*/_react.default.createElement("input", {
        "data-id": "".concat(dataId, "-input"),
        accept: accept,
        type: "file",
        disabled: disabled,
        onChange: this._onInputChange,
        ref: function ref(fi) {
          return _this4.fileInput = fi;
        }
      })));
    }
  }]);
  return FileDrop;
}(_react.Component);

exports.default = FileDrop;
(0, _defineProperty3.default)(FileDrop, "propTypes", {
  "data-id": _propTypes.default.string,
  accept: _propTypes.default.array,
  className: _propTypes.default.string,
  disabled: _propTypes.default.bool,
  fileName: _propTypes.default.node,
  replaceContent: _propTypes.default.bool,
  onRemove: _propTypes.default.func,
  onValidateFile: _propTypes.default.func,
  onValueChange: _propTypes.default.func,
  strings: _propTypes.default.objectOf(_propTypes.default.string)
});
(0, _defineProperty3.default)(FileDrop, "defaultProps", {
  "data-id": "input-filedrop",
  accept: [],
  replaceContent: false,
  onValidateFile: _underscore.default.noop,
  onValueChange: _underscore.default.noop,
  strings: {},
  disabled: false
});
module.exports = exports["default"];